// extracted by mini-css-extract-plugin
export var completeStocklists = "stockList-module--completeStocklists--SVcFV";
export var listLocation = "stockList-module--listLocation--pMYgt";
export var listText = "stockList-module--listText--56czj";
export var listWrapper = "stockList-module--listWrapper--m4Ht+";
export var wrapper = "stockList-module--wrapper--RUU8y";